import React, { useEffect, Fragment } from "react";
import { makeStyles, Container, Grid } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";

const useStyles = makeStyles((theme) => ({
  headingsContainer: {
    textAlign: "center",
    margin: "100px 0",
    color: theme.palette.secondary.light,
  },
  infoContainer: {
    textAlign: "justify",
    margin: "70px 0",
    color: theme.palette.secondary.light,
  },
  sectionHeading: {
    fontSize: "64px",
    color: theme.palette.secondary.light,
    fontWeight: 700,
    letterSpacing: 0.1,
    margin: "0 20px",
    lineHeight: "60px",
    [theme.breakpoints.down("md")]: {
      fontSize: "54px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "45px",
      lineHeight: "40px",
      marginTop: "30px",
    },
  },
  infoDesc: {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "36px",
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
      lineHeight: "30px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      lineHeight: "30px",
    },
  },
}));

function Contact() {
  const classes = useStyles();

  return (
    <Fragment>
      <Helmet>
        <title>Contact - d2p</title>
      </Helmet>
      <PageBanner title="Contact" image="/assets/images/bg4.jpg" />
      <div className={classes.headingsContainer}>
        <h6 style={{ fontWeight: 400, fontSize: "14px", letterSpacing: 7 }}>
          Contact
        </h6>
        <h2 className={classes.sectionHeading}>Decade 2 Publishing</h2>
      </div>
      <Container>
        <div className={classes.infoContainer}>
          <h3 className={classes.infoDesc}>
            Decade 2 Publishing is the literary division of Continent 5 Media
            Group, Inc., a Nevada corporation. To contact us, please email:
            <a href="#"> d2p@Continent5Media.com</a>
          </h3>
        </div>
      </Container>
    </Fragment>
  );
}
export default Contact;
